module.exports = __webpack_public_path__ + "img/MSB.be7d35b3.png";